/**
 * contractDetailPtbfApi — RTK Query slice cho Contract Detail "Add Pay PTBF"
 * batch dialog (artifact C3, Access frmProcurementQryDetailsAddPayPTBF).
 *
 * Endpoints (BE app/api/v1/endpoints/purchase/contract_detail_ptbf.py):
 *   POST /purchase/contract-detail/ptbf/preview — compute chain + header context
 *   POST /purchase/contract-detail/ptbf/save    — batch insert paydata
 *
 * Types snake_case khớp BE models (app/models/purchase/contract_detail_ptbf.py).
 */
import { baseApi } from './baseApi'

/** 1 dòng user nhập trong input grid (đa số optional — BE tự derive). */
export interface PtbfRowInput {
  payment_type?: string | null
  truck_id?: string | null
  bank_name?: string | null
  quantity_kg?: number | null
  pct_pay?: number | null
  advanced_usd?: number | null
  price?: number | null
  futures?: number | null
  requested_fx?: number | null
  price_unit?: string | null
  sub_price?: number | null
  advanced_sub_usd?: number | null
  request_sub_usd?: number | null
  request_sub_vnd?: number | null
  description?: string | null
  vat_amount_vnd?: number | null
}

export interface PtbfPreviewRequest {
  contract_no: string
  requested_fx?: number | null
  futures?: number | null
  rows: PtbfRowInput[]
}

export interface PtbfSaveRequest extends PtbfPreviewRequest {
  xntt_no?: string | null
}

/** 1 dòng preview read-only (output query ProcurementPay_WritePTBF). */
export interface PtbfPreviewRow {
  date: string
  contract_no: string
  payment_type: string | null
  truck_id: string | null
  bank_name: string | null
  to_be_requested: number | null
  quantity_kg: number | null
  price: number | null
  futures: number | null
  price_unit: string | null
  requested_fx: number | null
  advanced_usd: number | null
  request_usd: number | null
  request_vnd: number | null
  vat_amount_vnd: number | null
  description: string | null
  sub_price: number | null
  request_sub_usd: number | null
  request_sub_vnd: number | null
  advanced_sub_usd: number | null
}

/** Field context header dialog (read-only). */
export interface PtbfContext {
  fixed_fx: number | null
  provi_market_rate: number | null
  vat_txt: string | null
  pending: number | null
  pending_provisional: number | null
  pending_fixation: number | null
  requested_fx: number | null
}

export interface PtbfPreviewResponse {
  rows: PtbfPreviewRow[]
  new_pending_provisional: number | null
  new_pending_fixation: number | null
  context: PtbfContext
}

export interface PtbfSaveResponse {
  raw_records: number
  errors: number
}

export const contractDetailPtbfApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    ptbfPreview: b.mutation<PtbfPreviewResponse, PtbfPreviewRequest>({
      query: (body) => ({
        url: '/purchase/contract-detail/ptbf/preview',
        method: 'POST',
        body,
      }),
    }),
    ptbfSave: b.mutation<PtbfSaveResponse, PtbfSaveRequest>({
      query: (body) => ({
        url: '/purchase/contract-detail/ptbf/save',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { usePtbfPreviewMutation, usePtbfSaveMutation } = contractDetailPtbfApi
